import React, { useState, useEffect } from 'react';
import { 
  TextField, Button, Grid, Typography, Paper, Accordion, AccordionSummary, AccordionDetails,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es } from 'date-fns/locale';
import { CreditorService } from '../services/creditorService';
import { LobService } from '../services/lobService';
import { formatToCLP } from '../services/monedaService';
import { format } from 'date-fns';

const GeneradorContratos = () => {
  const [clientData, setClientData] = useState({
    identifier: '',
    firstName: '',
    lastName: '',
    email: '',
    numContrato: '',
    fechaContrato: null,
    observaciones: '',
  });

  const [creditors, setCreditors] = useState([]);
  const [linesOfBusiness, setLinesOfBusiness] = useState([]);
  const [installments, setInstallments] = useState({});

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const contractData = await LobService.getContractID();
        setClientData({
          identifier: contractData.identifier || '',
          firstName: contractData.firstName || '',
          lastName: contractData.lastName || '',
          email: contractData.email || '',
          numContrato: contractData.numContrato || '',
          fechaContrato: contractData.fechaContrato ? new Date(contractData.fechaContrato) : null,
          observaciones: contractData.observaciones || '',
        });
        setLinesOfBusiness(contractData?.contract_Line || []);
        
        const creditorsData = await CreditorService.getCreditors();
        setCreditors(creditorsData);

        // Obtener cuotas del contrato
        if (contractData.identifier && contractData.numContrato) {
          const cuotasData = await LobService.getCuotasContrato(contractData.identifier, contractData.numContrato);
          setInstallments(cuotasData);
        }
      } catch (error) {
        console.error('Error fetching initial data:', error);
      }
    };
    fetchInitialData();
  }, []);

  const handleClientDataChange = (e) => {
    const { name, value } = e.target;
    setClientData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAddCreditor = (newCreditor) => {
    setCreditors(prevCreditors => [...prevCreditors, newCreditor]);
  };

  const handleDeleteCreditor = (id) => {
    setCreditors(prevCreditors => prevCreditors.filter(creditor => creditor.id !== id));
  };

  const handleAddLineOfBusiness = (newLine) => {
    setLinesOfBusiness(prevLines => [...prevLines, newLine]);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Generador de Contratos
        </Typography>

        {/* ... (El resto del código para Datos del Cliente, Acreedores y Líneas de Negocio permanece igual) ... */}

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Cuotas Pactadas</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>N° de Cuota</TableCell>
                    <TableCell>Fecha</TableCell>
                    <TableCell>Monto</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {installments.cuotas && installments.cuotas.map((cuota, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{format(new Date(cuota.fecha), 'dd/MM/yyyy')}</TableCell>
                      <TableCell>{formatToCLP(cuota.monto)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        <Button variant="contained" color="primary" sx={{ mt: 3 }}>
          Generar Contrato
        </Button>
      </Paper>
    </LocalizationProvider>
  );
};

export default GeneradorContratos;